export const context = {
  actions: null,
  state: null,
};
